module.exports = "pegasus/assets/themelp1/small/30.png";